import { AppFrameContextService } from '@sdbn/common';
import { AppClientConfigurationService } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';
import { AbstractStepController, FlowStepHandleResult, HandleResultType, StepControl, WizardServiceLocator } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { TerminalContextConstants } from '@sdbn/tmc-common';
import { DateTime } from 'luxon';

export class VisitorPrintIdentityCardController extends AbstractStepController {

    private terminalConnectorUrl: string;

    configurationService: AppClientConfigurationService;
    appFrameContextService: AppFrameContextService;
    translationService: TranslationService;
    appServerAPI: AppServerAPI;

    constructor() {
        super();
        this.configurationService = WizardServiceLocator.injector.get(AppClientConfigurationService);
        this.appServerAPI = WizardServiceLocator.injector.get(AppServerAPI);
        this.appFrameContextService = WizardServiceLocator.injector.get(AppFrameContextService);
        this.translationService = WizardServiceLocator.injector.get(TranslationService);
        const terminalHardwareUrl = this.configurationService.getDeviceParameter('terminalhardwareconnector.url');
        if (terminalHardwareUrl != null && terminalHardwareUrl.value.trim().length > 0) {
          this.terminalConnectorUrl = this.configurationService.getDeviceParameter('terminalhardwareconnector.url').value;
        }
    }

    onContextChange(contextChange: ContextChange) {
    }

    onRegisterToDashboardContext() {
      if (this.terminalConnectorUrl == null) {
        console.log('No terminalConnector URL configured. Skip printing');
        this.wizardComponent.next();
      } else {
        this.appServerAPI.execute(this.terminalConnectorUrl + '/io/printer/print', this.buildPrintJobData()).subscribe(result => {
          console.log('preint finished');
          this.wizardComponent.next();
        },
        error => {
          console.log('error received');
          this.wizardComponent.next();
        });
      }
    }

    public handleFlow(): FlowStepHandleResult {
      const result = new FlowStepHandleResult();
      result.type = HandleResultType.PROCESSING;
      return result;
    }

    getControls(): StepControl[] {
        return new Array<StepControl>();
    }

    private buildPrintJobData(): any {
      const name = this.dashboardContext.getContextValue(TerminalContextConstants.lastname);
      const firstname = this.dashboardContext.getContextValue(TerminalContextConstants.firstname);
      const company = this.dashboardContext.getContextValue(TerminalContextConstants.company);
      const numberPlate = this.dashboardContext.getContextValue(TerminalContextConstants.numberPlate);
      const reason = this.dashboardContext.getContextValue(TerminalContextConstants.reasonForVisit);
      const visitedPerson = this.dashboardContext.getContextValue(TerminalContextConstants.visitedPerson);
      const registrationCode = this.dashboardContext.getContextValue(TerminalContextConstants.registrationCode);
      const registrationFinished = this.dashboardContext.getContextValue(TerminalContextConstants.registrationFinished);

      return {
        yardKey: this.appFrameContextService.tenant.value.key,
        type: 'VISITOR_IDENTITY_CARD',
        labels: {
          'label.name': this.translationService.translate('tmc-yard.entity.visit.name'),
          'label.company': this.translationService.translate('tmc-yard.entity.visit.company'),
          'label.numberPlate': this.translationService.translate('tmc-yard.entity.visit.numberplate'),
          'label.reason': this.translationService.translate('tmc-yard.entity.visit.reason'),
          'label.visitedPerson': this.translationService.translate('tmc-yard.entity.visit.visited-person'),
          'label.registrationFinished': this.translationService.translate('tmc-yard.entity.visit.registrationFinished')

        },
        values: {
          name: name,
          firstname : firstname,
          company: company,
          numberPlate: numberPlate,
          reason:reason,
          visitedPerson: visitedPerson,
          registrationFinished: DateTime.fromJSDate(new Date(registrationFinished)).toFormat("dd.MM.yyyy HH:mm"),
          qrCode: registrationCode != null ? 'tmc-visit://visitor/' + registrationCode : null
        }
      };
    }
}
